import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressRing',
  props: {
    percentValue: null,
    label: null,
    ariaLabel: null
  },
  setup: function setup(__props) {
    var props = __props;
    var center = 50;
    var radius = 48;
    var circumference = 2 * Math.PI * radius;
    var primaryPercent = computed(function () {
      return Math.max(0, Math.min(100, props.percentValue));
    });
    var overshootPercent = computed(function () {
      return Math.max(0, Math.min(100, props.percentValue - 100));
    });
    var baseArcStyle = computed(function () {
      return {
        strokeDasharray: "".concat(circumference),
        strokeDashoffset: "".concat(circumference * (1 - primaryPercent.value / 100))
      };
    });
    var overshootArcStyle = computed(function () {
      return {
        strokeDasharray: "".concat(circumference),
        strokeDashoffset: "".concat(circumference * (1 - overshootPercent.value / 100))
      };
    });
    var ariaLabel = computed(function () {
      return props.ariaLabel || "Progress ".concat(props.label);
    });
    return {
      __sfc: true,
      props: props,
      center: center,
      radius: radius,
      circumference: circumference,
      primaryPercent: primaryPercent,
      overshootPercent: overshootPercent,
      baseArcStyle: baseArcStyle,
      overshootArcStyle: overshootArcStyle,
      ariaLabel: ariaLabel
    };
  }
});